module.exports = __webpack_public_path__ + "static/media/training.dad3b238.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/training.svg
// module id = 301
// module chunks = 0